import React from "react";
import { Link } from "react-router-dom";
import Qoute from "./Quote";

export default function Banner() {
  return (
    <>
      <div className="container-fluid p-0 pb-5">
        <div className="owl-carousel header-carousel position-relative mb-5">
          <div className="owl-carousel-item position-relative">
            <img
              className="img-fluid"
              src="/assets/img/carousel-1.jpg"
              alt=""
            />
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
              style={{ background: "rgba(6, 3, 21, 0.5)" }}
            >
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-10 col-lg-6 col-md-6">
                    <h5 className="text-white text-uppercase mb-3 animated slideInDown">
                      One Step Transport Services
                    </h5>
                    <h1 className="display-3 text-white animated slideInDown mb-4">
                      Move Smarter with Nexways
                    </h1>
                    <p className="fs-5 fw-medium text-white mb-4 pb-2">
                      A Visual Tour of Our Transportation Services
                    </p>
                    <Link
                      to={"/aboutus"}
                      className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                    >
                      Read More
                    </Link>
                    <Link
                      to={"/newQuote"}
                      className="btn btn-secondary py-md-3 px-md-5 animated slideInRight"
                    >
                      Free Quote
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
